module.exports = __webpack_public_path__ + "img/demo.46f374bf.png";